var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.83301C2 2.72844 2.89543 1.83301 4 1.83301H9.33333C11.9107 1.83301 14 3.92235 14 6.49967V13.1663C14 14.2709 13.1046 15.1663 12 15.1663H4C2.89543 15.1663 2 14.2709 2 13.1663V3.83301ZM8.66667 3.16634H4C3.63181 3.16634 3.33333 3.46482 3.33333 3.83301V13.1663C3.33333 13.5345 3.63181 13.833 4 13.833H12C12.3682 13.833 12.6667 13.5345 12.6667 13.1663V6.49967H8.66667V3.16634ZM12.3893 5.16632C11.9609 4.18569 11.0742 3.45105 10 3.233V5.16632H12.3893ZM4.66667 7.16634H7.33333V5.83301H4.66667V7.16634ZM4.66667 9.83301H11.3333V8.49967H4.66667V9.83301ZM11.3333 12.4997H4.66667V11.1663H11.3333V12.4997Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvice);
export default __webpack_public_path__ + "static/media/advice.4f001f4516136cb5a913c9f485d73d7d.svg";
export { ForwardRef as ReactComponent };